<script setup lang="ts">
// A status as an icon and words, with color only as a hint.
import { computed } from 'vue'
import { Alert02Icon, CheckmarkCircle02Icon, Clock01Icon, InformationCircleIcon, Cancel01Icon } from '@/components/icons'

const props = defineProps<{ tone: 'success' | 'warning' | 'danger' | 'info' | 'neutral'; label: string; title?: string }>()
const icon = computed(() => ({ success: CheckmarkCircle02Icon, warning: Alert02Icon, danger: Cancel01Icon, info: InformationCircleIcon, neutral: Clock01Icon })[props.tone])
const cls = computed(() => ({ success: 'badge-success', warning: 'badge-warning', danger: 'badge-danger', info: 'badge-info', neutral: 'badge-neutral' })[props.tone])
</script>

<template>
  <span class="badge inline-flex items-center gap-1" :class="cls" :title="title">
    <component :is="icon" :size="12" />
    <span>{{ label }}</span>
  </span>
</template>
